import React from 'react';

import Breadcrumbs from '../components/Breadcrumb/Breadcrumbs';
import Container from './container/Container';
import Headline from '../components/Headline';

/* import useInit from '../../global/useInit'; */
import { useAppSelector } from '../app/hooks';
import { RequestHandler } from '../app/RequestHandler';
import './MasterLayout.scss';
import useInit from '../global/useInit';

interface Props {
  children: React.ReactNode | React.ReactNode[];
}

const MasterLayout: React.FC<Props> = ({ children }) => {
  const translations = useAppSelector((state) => state.translations.value);
  useInit();

  const isAuth = window.location.href.includes('auth');
  const { applicationType } = new RequestHandler();
  const isStandalone = applicationType === 'standalone' || applicationType === 'local';

  return (
    <div className="container-body">
      {isAuth ? (
        <Container>
          {isStandalone ? null : <Breadcrumbs />}
          <Headline />
          <div className="frc-main-section">{children}</div>
        </Container>
      ) : (
        <>
          {Object.keys(translations).length > 0 && (
            <Container>
              {isStandalone ? null : <Breadcrumbs />}
              <Headline />
              <div className="frc-main-section">{children}</div>
            </Container>
          )}
        </>
      )}
    </div>
  );
};

export default MasterLayout;
